
import React from 'react';
import { GiftInfo } from '../types';

export const Gift: React.FC<{ info: GiftInfo }> = ({ info }) => {
  return (
    <group position={info.position} rotation={info.rotation}>
      <mesh>
        <boxGeometry args={info.size} />
        <meshStandardMaterial color={info.color} />
      </mesh>
      {/* Ribbon */}
      <mesh position={[0, 0, 0]} scale={[1.05, 1.05, 0.1]}>
        <boxGeometry args={info.size} />
        <meshStandardMaterial color="white" />
      </mesh>
      <mesh position={[0, 0, 0]} scale={[0.1, 1.05, 1.05]}>
        <boxGeometry args={info.size} />
        <meshStandardMaterial color="white" />
      </mesh>
    </group>
  );
};
